




























































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import EditUserProfilePersonalityInvestmentExperienceViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/edit-user-profile-personality/edit-user-profile-personality-investment-experience-view-model';

@Component({ name: 'EditUserProfilePersonalityInvestmentExperience' })
export default class EditUserProfilePersonalityInvestmentExperience extends Vue {
  @PropSync('isLoading', { type: Boolean, required: false, default: false })
  synced_is_loading!: boolean;

  flagship_dependents_view_model = Vue.observable(
    new EditUserProfilePersonalityInvestmentExperienceViewModel(this),
  );

  created() {
    this.flagship_dependents_view_model.initialize();
  }
}
